import React from 'react';
import './ValidationHistory.css';

export default function ValidationHistory({ results, selectedId, onSelect }) {
  if (!results.length) return null;
  return (
    <section className="card validation-history mb-4" aria-label="Validation history">
      <div className="validation-history__heading">
        <div>
          <h2>Validation history</h2>
          <p>Latest 50 saved runs for this architecture version. Select a run to inspect its report.</p>
        </div>
        <span className="validation-history__count">{results.length} saved {results.length === 1 ? 'run' : 'runs'}</span>
      </div>
      <div className="table-responsive">
        <table className="table table-hover validation-history__table mb-0">
          <thead><tr><th>Commit</th><th>Validated</th><th>Result</th><th>Violations</th><th>Warnings</th><th>Report</th></tr></thead>
          <tbody>{results.map(result => (
            <tr key={result.id} className={`${result.passed ? 'table-success' : 'table-danger'}${selectedId === result.id ? ' table-active' : ''}`}>
              <td><code title={result.commitId || undefined}>{result.commitId || 'Commit unavailable'}</code></td>
              <td><time dateTime={result.validatedAt} title={result.validatedAt}>
                {new Date(result.validatedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
                <span className="validation-history__time">{new Date(result.validatedAt).toLocaleTimeString()}</span>
              </time></td>
              <td><span className={`validation-history__status ${result.passed ? 'validation-history__status--passed' : 'validation-history__status--failed'}`}>
                <span aria-hidden="true">{result.passed ? '✓' : '×'}</span>
                <span className={result.passed ? 'text-success-emphasis' : 'text-danger-emphasis'}>{result.passed ? 'Passed' : 'Failed'}</span>
              </span></td>
              <td className="validation-history__number">{result.totalViolations}</td><td className="validation-history__number">{result.totalWarnings}</td>
              <td><button type="button" className="validation-history__report"
                aria-pressed={selectedId === result.id}
                aria-label={`View validation for ${result.commitId || 'unknown commit'} at ${result.validatedAt}`}
                onClick={() => onSelect(result)}>
                {selectedId === result.id ? 'Viewing report' : 'View report'}
                <span aria-hidden="true">{selectedId === result.id ? '✓' : '→'}</span>
              </button></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </section>
  );
}
